"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const botones_1 = require("../../../botones");
const drillObjectModal_1 = require("./drillObjectModal");
class ObjectCell extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onModalCerrar = (path) => {
            if (path != null) {
                this.props.onDrillDown(path);
            }
            this.setState({ showDrillModal: false });
        };
        this.state = {};
    }
    render() {
        const keys = Object.keys(this.props.value);
        const { props, state } = this;
        return (React.createElement("div", { style: { overflowX: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" } },
            React.createElement("span", null,
                React.createElement(botones_1.Link, { style: "success", iconClass: "fa fa-list-alt", onClick: () => this.setState({ showDrillModal: true }) }),
                keys.map(key => React.createElement(botones_1.Link, { style: "info", key: key, onClick: () => props.onDrillDown([key]) }, key)),
                React.createElement(drillObjectModal_1.DrillObjectComponent, { show: !!state.showDrillModal, value: props.value, onCerrar: this.onModalCerrar }))));
    }
}
exports.ObjectCell = ObjectCell;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/grid2Base/components/cells/objectcell.js
// module id = 2217
// module chunks = 0